import { Check } from "lucide-react";

export default function SingleCheckBox({ checked, setChecked, children }) {
  return (
    <label className="flex flex-row items-top md:items-center justify-start cursor-pointer gap-4">
      <input
        type="checkbox"
        checked={checked}
        onChange={() => setChecked(!checked)}
        className="hidden"
      />
      <div
        className={`aspect-square w-[24px] h-[24px] flex items-center justify-center rounded-[8px] ${
          checked ? "bg-accent" : "border-2 border-gray-200"
        } transition-all`}
      >
        {checked && <Check size="16" color="#FFFFFF" />}
      </div>
      {children}
    </label>
  );
}
